// utils/loanUtils.js
import moment from "moment";

export const processDirectusLoan = (loan) => {
  // Calculate paid amount from transactions
  const repayments = loan.loan_transactions
    .filter((t) => t.transaction_type === "Loan Repayment")
    .map((p) => ({
      payment_date: moment(p.transaction_date),
      amount: p.amount,
    }));

  // Get disbursement details
  const disbursement = loan.loan_transactions.find(
    (t) => t.transaction_type === "Loan Disbursement"
  );

  const paid_amount = repayments.reduce((sum, t) => sum + t.amount, 0);
  const outstanding_balance = Math.max(0, Number(loan.amount)) - paid_amount;

  // Calculate days delinquent
  const dueDate = moment(loan.next_payment_date);
  const days_delinquent = Math.max(0, moment().diff(dueDate, "days"));

  // Calculate payment consistency
  const total_payments = repayments.length;
  const on_time_payments = repayments.filter((p) =>
    p.payment_date.isSameOrBefore(dueDate)
  ).length;

  return {
    ...loan,
    amount: Number(loan.amount) || 0,
    paid_amount,
    outstanding_balance,
    days_delinquent,
    disbursement_date: disbursement?.transaction_date || loan.approval_date,
    payment_history: {
      total_payments,
      on_time_payments,
      consistency: total_payments > 0 ? on_time_payments / total_payments : 0,
    },
    borrower: {
      first_name: loan.borrower?.first_name || "Unknown",
      last_name: loan.borrower?.last_name || "Borrower",
      credit_score: loan.borrower?.credit_score || 650,
    },
  };
};

export const normalizeTermOptions = (input) => {
  if (!input) return [];

  let raw = input;

  if (typeof input === "string") {
    try {
      const parsed = JSON.parse(input);
      raw = Array.isArray(parsed) ? parsed : input.split(",");
    } catch (error) {
      raw = input.split(",");
    }
  }

  if (!Array.isArray(raw)) {
    raw = [raw];
  }

  return Array.from(
    new Set(
      raw
        .map((value) => Number.parseInt(value, 10))
        .filter((value) => Number.isFinite(value) && value > 0)
    )
  ).sort((a, b) => a - b);
};
// Helper to generate expected due dates
const generateDueDates = (loan) => {
  const dates = [];
  const startDate = moment(loan.approval_date);
  const frequency = loan.loan_product.payment_frequency;
  const term = loan.loan_term ?? loan.loan_product.loan_term;

  let addFn = "months";
  let interval = 1;

  switch (frequency) {
    case "weekly":
      addFn = "weeks";
      interval = 1;
      break;
    case "bi_weekly":
      addFn = "weeks";
      interval = 2;
      break;
    case "monthly":
    default:
      addFn = "months";
      interval = 1;
  }

  for (let i = 0; i < term; i++) {
    dates.push(startDate.clone().add((i + 1) * interval, addFn));
  }

  return dates;
};
